import "reflect-metadata";
import React from "react";
import i18next from "i18next";
import "reflect-metadata";
import { HelmetProvider } from "react-helmet-async";
import { createRoot, hydrateRoot } from 'react-dom/client';
import * as r from 'react-dom';
import { BrowserRouter, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";
import { QueryClientProvider, QueryClient, hydrate } from "react-query";
import { ReactQueryDevtools } from 'react-query/devtools';
import { I18nContext } from '@haohan/react-i18n';
import axios from "axios";
import { SiteApp } from "../app";
import { SiteQueryConfig } from "../ssr";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://ce29108ff69c42e6067393c20ef0e197@o4505871863250944.ingest.sentry.io/4505871877799936",
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      ),
    }),
    new Sentry.Replay()
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/haohan\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
// import { io, Manager } from 'socket.io-client';

// const manager = new Manager('ws://localhost:3012', {path: '/ws'});

// const socket = io('ws://localhost:3012', {
// 	path: '/ws/game/game',
// 	transports: ['websocket'],
// 	withCredentials: true
// });

// const socket = manager.socket('/game')

// setInterval(() => {
// 	const r = socket.emit('action', {msg: 12, err: 12})
// }, 5000);

function Run() {
	return (
			<BrowserRouter>
				<RunInner/>
			</BrowserRouter>
	);
}


function RunInner() {
	const { pathname } = useLocation();
	const lang = pathname.startsWith('/en')
		? 'en'
		: 'ru';
	React.useLayoutEffect(() => {
		i18next.changeLanguage(lang);
		const id = axios.interceptors.request.use(config => {
			config.headers['X-APP-LANGUAGE'] = lang;
			return config;
		});
		return () => axios.interceptors.request.eject(id);
	}, [lang]);
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				refetchOnMount: false,
				refetchOnWindowFocus: false,
			}
		}
	});
	if (window['__REACT_QUERY_STATE__']) {
		hydrate(queryClient, window['__REACT_QUERY_STATE__']);
	}
	return (
		<HelmetProvider>
			<I18nContext.Provider value={{ssr: false, lang}}>
				<QueryClientProvider client={queryClient}>
					<SiteQueryConfig>
						
						<SiteApp
							//routes={siteRoutes.map(r => ({
							//	...r,
							//	element: React.createElement(r.view as any),
							//}))}
						/>
					</SiteQueryConfig>
				</QueryClientProvider>
			</I18nContext.Provider>
		</HelmetProvider>
	);
}

const containerEl = document.getElementById("root");
if (containerEl.childNodes.length === 0) {
	const root = createRoot(containerEl); // createRoot(container!) if you use TypeScript
	root.render(<Run/>);
} else {
	hydrateRoot(containerEl, <Run/>);
}
